module.exports = __webpack_public_path__ + "static/winleader-084c01a34cc01c0f1a8c2cebe3e1dbf2.pdf";